import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Bar,
  BarChart,
  LabelList,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';

const BarChartLabel = ({ x, y, value }) => {
  const newX = x + 5;
  const newY = y - 5;
  return (
    <text x={newX} y={newY} fill="rgb(255 255 255 / 65%)" textAnchor="start">
      {value}
    </text>
  );
};

export const RankChart = ({ color, data = [] }) => {
  const { t } = useTranslation();

  if (data.length === 0) {
    return (
      <ResponsiveContainer width="100%" height={400}>
        <div
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div>{t('No Data')}</div>
        </div>
      </ResponsiveContainer>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={data.length * 40 || 400}>
      <BarChart
        width="100%"
        height={10 * data.length}
        data={data}
        layout="vertical"
      >
        <YAxis type="category" axisLine={false} display="none" />
        <XAxis type="number" axisLine={false} display="none"></XAxis>

        <Bar dataKey="value" fill={color || '#0e9347'} barSize={5}>
          <LabelList
            dataKey={(obj) => `${obj.name} - (${obj.value})`}
            position="top"
            fill="#fff"
            content={<BarChartLabel x={-1} y={-1} width={-1} value={-1} />}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
